module.exports = __webpack_public_path__ + "img/professional-icon-02.a915ac2c.png";